import axios from 'axios'
import { AppUrl } from '@/assets/js/variables'

const state = {
  title: null,
  status: {
    loading: false,
    noData: false
  },
  table: {
    items: []
  }
}

const getters = {

}

const actions = {
  getTable ({commit}, filter) {
    commit('SET_loading', true)
    return new Promise((resolve, reject) => {
      axios.post(AppUrl, {
        task: 'pricesDeviation',
        payload: {
          sellers: filter.sellers,
          categories: filter.categories,
          brands: filter.brands
        }
      })
        .then(response => {
          if (response.data.payload) {
            commit('SET_title', response.data.payload.title)
            console.log('RANKING', response.data.payload)
            for (let key in response.data.payload.table) {
              if (response.data.payload.table[key].constructor === Array) {
                commit('SET_loading', false)
                commit('SET_noData', true)
                resolve()
                return
              }
            }
            commit('SET_loading', false)
            commit('SET_noData', false)
            commit('SET_table', response.data.payload.table)
            resolve()
          } else {
            commit('SET_loading', false)
          }
        })
        .catch(error => {
          console.log(error)
        })
    })
  }
}

const mutations = {
  SET_loading (state, bool) {
    state.status.loading = bool
  },
  SET_noData (state, bool) {
    state.status.noData = bool
  },
  SET_table (state, data) {
    state.table.items = data
  },
  SET_title (state, data) {
    state.title = data
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/analytics/sellersRanking.js